import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/timer.png'
import _imports_1 from '../assets/head1.png'
import _imports_2 from '../assets/head2.png'
import _imports_3 from '../assets/head5.png'
import _imports_4 from '../assets/head4.png'
import _imports_5 from '../assets/head6.png'


const _withScopeId = n => (_pushScopeId("data-v-7ca33f9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "watch-home"
}
const _hoisted_2 = { class: "wrist-watch-header" }
const _hoisted_3 = { class: "status-wrapper" }
const _hoisted_4 = { class: "icon-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "statusText" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "status" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "content real-name-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实名状态:", -1))
const _hoisted_13 = { class: "package-section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "inline" }),
  /*#__PURE__*/_createElementVNode("span", { class: "headText" }, "套餐用量")
], -1))
const _hoisted_15 = { class: "valid-card" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "valid-info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-title" }, "套餐有效期", -1))
const _hoisted_19 = { class: "valid-time" }
const _hoisted_20 = { class: "usage-grid" }
const _hoisted_21 = { class: "usage-card" }
const _hoisted_22 = { class: "usage-title-row" }
const _hoisted_23 = { class: "usage-icon voice" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "usage-title" }, "语音通话", -1))
const _hoisted_25 = { class: "ring-inner" }
const _hoisted_26 = { class: "percent blue" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "used-label" }, "已使用", -1))
const _hoisted_28 = { class: "remain" }
const _hoisted_29 = { class: "blue" }
const _hoisted_30 = { class: "total" }
const _hoisted_31 = { class: "usage-card" }
const _hoisted_32 = { class: "usage-title-row" }
const _hoisted_33 = { class: "usage-icon flow" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "usage-title" }, "流量", -1))
const _hoisted_35 = {
  key: 0,
  class: "warn-tag"
}
const _hoisted_36 = { class: "ring-inner" }
const _hoisted_37 = { class: "percent orange" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "used-label" }, "已使用", -1))
const _hoisted_39 = { class: "remain" }
const _hoisted_40 = { class: "orange" }
const _hoisted_41 = { class: "total" }
const _hoisted_42 = { class: "orange" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "inline" }),
  /*#__PURE__*/_createElementVNode("span", { class: "headText" }, "功能界面")
], -1))
const _hoisted_44 = { class: "featureList" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "亲情号管理", -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "充值续费", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "在线客服", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "手表管理", -1))
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clerk" }, "专属客服", -1))
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupTitle" }, "长按识别进入小程序", -1))
const _hoisted_63 = ["src"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupTitle" }, "添加一对一专属客服", -1))
const _hoisted_65 = ["src"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupTitle" }, "手机号校验", -1))
const _hoisted_67 = { style: {"margin":"16px"} }

import { computed, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { showDialog, showToast } from 'vant'
  import dxIcon from '@/assets/dx_icon.png'
  import ltIcon from '@/assets/lt_icon.png'
  import ydIcon from '@/assets/yd_icon.png'
  import appletImg from '@/assets/noapplet.png'
  import officialImg from '@/assets/official.png'
  import store from '@/store'
  import { createFamilyNumberRouteLocation } from '@/utils/familyNumberAccess'
  import {
    getCheckCode,
    getWifiCustomizationCardSendCode,
    getWifiCustomizationCardQueryCardMsgV2,
    getWifiLoginAuth
  } from '@/api'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WatchHome',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const appletStatus = ref(false)
  const officialStatus = ref(false)
  const realNameAutoPrompted = ref(false)
  const cardData = ref<any>()
  const phoneStatus = ref(false)
  let code = ref('');
  let phone = ref('');

  const operatorMap: Record<number, { name: string; icon: string }> = {
    1: { name: '中国移动', icon: ydIcon },
    2: { name: '中国联通', icon: ltIcon },
    3: { name: '中国电信', icon: dxIcon },
    4: { name: '中国电信', icon: dxIcon }
  }

  const operatorInfo = computed(() => {
    return operatorMap[Number(cardData.value?.operator)] || { name: '未知运营商', icon: dxIcon }
  })

  const realNameText = computed(() => {
    const listRealName = new Map([
      ['1', '未认证'],
      ['2', '已认证'],
      ['3', '认证失败'],
      ['4', '部分认证'],
      ['5', '二次实名中'],
    ])
    return listRealName.get(String(cardData.value?.realNameStatus || '')) || '- -'
  })

  const realNameClass = computed(() => {
    const realNameStatus = String(cardData.value?.realNameStatus || '')
    if (realNameStatus === '2') return 'success'
    if (realNameStatus === '3') return 'danger'
    if (realNameStatus === '1' || realNameStatus === '4') return 'warning'
    if (realNameStatus === '5') return 'processing'
    return 'default'
  })

  const realNameUrl = computed(() => {
    return cardData.value?.realNameUrl || ''
  })

  const canRealNameJump = computed(() => {
    return !!realNameUrl.value
  })

  const voiceTotal = computed(() => {
    return toNumber(cardData.value?.totalMessageMinute)
  })

  const voiceUsed = computed(() => {
    return toNumber(cardData.value?.totalUsedMessageMinute)
  })

  const voiceLeave = computed(() => {
    return Math.max(voiceTotal.value - voiceUsed.value, 0)
  })

  const voicePercent = computed(() => {
    return getPercent(voiceUsed.value, voiceTotal.value)
  })

  const flowTotalText = computed(() => {
    if (cardData.value?.boundlessFlag) return '不限量'
    return formatFlowToGb(cardData.value?.flowTotal)
  })

  const flowLeaveText = computed(() => {
    if (cardData.value?.boundlessFlag) return '不限量'
    return formatFlowToGb(cardData.value?.flowLeave)
  })

  const flowPercent = computed(() => {
    if (cardData.value?.boundlessFlag) return 0
    const flowTotal = Number(cardData.value?.flowTotal || 0)
    const flowLeave = Number(cardData.value?.flowLeave || 0)
    return getPercent(flowTotal - flowLeave, flowTotal)
  })

  function getPercent(used: number, total: number) {
    if (!total || total <= 0) return 0
    const percent = Math.round(used / total * 100)
    return Math.min(Math.max(percent, 0), 100)
  }

  function toNumber(value: any) {
    const numberValue = Number(value || 0)
    return Number.isFinite(numberValue) ? numberValue : 0
  }

  function formatFlowToGb(value: any) {
    const gbValue = toNumber(value) / 1024
    return `${Number(gbValue.toFixed(2))}G`
  }


  const phoneRule = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  const sendCodeButtonText = ref<string>('发送验证码')

  const setIntervalTimer = () => {
    let timerout = 60
    sendCodeButtonText.value = `${timerout}秒后重试`
    const timer = setInterval(() => {
      timerout --;
      sendCodeButtonText.value = `${timerout}秒后重试`
      if (timerout <= 0) {
        sendCodeButtonText.value = "发送验证码";
        clearInterval(timer);
      }
    }, 1000);
  }

  const getCode = () => {
    if (!phoneRule.test(phone.value)) {
      showToast({ message: "请输入正确的手机号", forbidClick: true, });
      return;
    }
    getWifiCustomizationCardSendCode({ mobile: phone.value })
      .then((res: any) => {
      if (res.code === 200) {
        showToast({ message: "验证码发送成功", forbidClick: true, });
        setIntervalTimer()
      } else {
        showToast({ message: res.message, forbidClick: true, });
      }
    })
  }

  const onSubmit = () => {
    let params = {
      mobile: phone.value,
      code: code.value,
      iccid: route.params.iccid
    }
    getCheckCode(params)
      .then((res: any) => {
      if (res.code === 200) {
        phoneStatus.value = false;
        localStorage.setItem('watchPhone', phone.value)
        autoPromptRealName()
      } else {
        showToast({ message: res.message, forbidClick: true, });
      }
    })
  };
  function usageRingStyle(percent: number, color: string) {
    return {
      background: `conic-gradient(${color} ${percent * 3.6}deg, #e8e8e8 0deg)`
    }
  }

  function showRealNameDialog() {
    if (!realNameUrl.value) return
    showDialog({
      title: '请完成实名认证',
      message: '套餐订购成功后，<span style="color: #1d8bfa;">请及时完成实名认证</span>。完成认证后，卡片才能正常使用相关服务。',
      allowHtml: true,
      showCancelButton: true,
      confirmButtonText: '去实名认证',
      cancelButtonText: '稍后再说'
    }).then(() => {
      window.location.href = realNameUrl.value
    }).catch(() => {})
  }

  function autoPromptRealName() {
    if (realNameAutoPrompted.value) return
    if (!realNameUrl.value) return
    realNameAutoPrompted.value = true
    showRealNameDialog()
  }

  function handleRealNameClick() {
    if (!realNameUrl.value) return
    showRealNameDialog()
  }

  function goPackage() {
    router.push({
      name: 'packageList',
      params: {
        iccid: route.params.iccid,
        phone: cardData.value.iccidShort || cardData.value.phone || '',
        status: cardData.value.cardStatus || '未知',
        operator: cardData.value.operator || ''
      },
      query: {
        source: 'watchHome'
      }
    })
  }

  function goKf() {
    const url = cardData.value?.watchesCustomerServiceUrl || sessionStorage.getItem('kfUrl')
    if (url) {
      window.location.href = url
      return
    }
    showToast('暂无客服链接')
  }

  function goFamilyManage() {
    router.push(createFamilyNumberRouteLocation(
      route.params.iccid,
      cardData.value?.agentPackageName
    ))
  }

  function goWatchManage() {
    appletStatus.value = true
  }

  function getCardMsg() {
    getWifiCustomizationCardQueryCardMsgV2({ iccid: route.params.iccid })
      .then((res: any) => {
        if (res.code === 200) {
          cardData.value = res.result
          if (res.result?.watchesCustomerServiceUrl) {
            store.commit('setKfUrl', res.result.watchesCustomerServiceUrl)
          }
          if (localStorage.getItem("watchPhone")) {
            autoPromptRealName()
          } else {
            phoneStatus.value = true;
          }
        } else {
          showToast({ message: res.message, forbidClick: true })
        }
      })
  }

  onMounted(() => {
    if (route.query.hasOwnProperty('userId')) {
      store.commit('setAppid', route.query.mpAppId)
      store.commit('setTenantId', route.query.cmeId)
      store.commit('setUserId', route.query.userId)
      getCardMsg()
    } else {
      getWifiLoginAuth(route.params.iccid, '/watchHome').then((res: any) => {
        if (res.code === 200) {
          window.location.href = res.result
        } else {
          showToast({ message: res.message, forbidClick: true })
        }
      })
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!

  return (cardData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: operatorInfo.value.icon,
                alt: "",
                class: "operator-icon"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(operatorInfo.value.name), 1),
              _createElementVNode("div", _hoisted_8, "状态：" + _toDisplayString(cardData.value.cardStatus || '- -'), 1)
            ])
          ]),
          _createElementVNode("li", _hoisted_9, "充值卡号: " + _toDisplayString(cardData.value.iccidShort || cardData.value.phone || '- -'), 1),
          _createElementVNode("li", _hoisted_10, "ICCID: " + _toDisplayString(_unref(route).params.iccid || '- -'), 1),
          _createElementVNode("li", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", {
              class: _normalizeClass(["real-name-tag", realNameClass.value]),
              onClick: handleRealNameClick
            }, [
              _createTextVNode(_toDisplayString(realNameText.value) + " ", 1),
              (canRealNameJump.value)
                ? (_openBlock(), _createBlock(_component_van_icon, {
                    key: 0,
                    name: "arrow"
                  }))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("section", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(cardData.value.billStartDate || '--') + " 至 " + _toDisplayString(cardData.value.billEndDate || '--'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_van_icon, { name: "phone-o" })
                ]),
                _hoisted_24
              ]),
              _createElementVNode("div", {
                class: "ring",
                style: _normalizeStyle(usageRingStyle(voicePercent.value, '#1f75ff'))
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(voicePercent.value) + "%", 1),
                  _hoisted_27
                ])
              ], 4),
              _createElementVNode("div", _hoisted_28, [
                _createTextVNode("剩余 "),
                _createElementVNode("span", _hoisted_29, _toDisplayString(voiceLeave.value), 1),
                _createTextVNode(" 分钟")
              ]),
              _createElementVNode("div", _hoisted_30, "共" + _toDisplayString(voiceTotal.value) + "分钟", 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_van_icon, { name: "bar-chart-o" })
                ]),
                _hoisted_34,
                (flowPercent.value >= 80)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, "余量不足"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "ring",
                style: _normalizeStyle(usageRingStyle(flowPercent.value, '#ff8412'))
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(flowPercent.value) + "%", 1),
                  _hoisted_38
                ])
              ], 4),
              _createElementVNode("div", _hoisted_39, [
                _createTextVNode("剩余 "),
                _createElementVNode("span", _hoisted_40, _toDisplayString(flowLeaveText.value), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createTextVNode("总量 "),
                _createElementVNode("span", _hoisted_42, _toDisplayString(flowTotalText.value), 1)
              ])
            ])
          ])
        ]),
        _hoisted_43,
        _createElementVNode("ul", _hoisted_44, [
          _createElementVNode("li", {
            class: "featureItem",
            onClick: goFamilyManage
          }, _hoisted_47),
          _createElementVNode("li", {
            class: "featureItem",
            onClick: _withModifiers(goPackage, ["prevent"])
          }, _hoisted_51, 8, _hoisted_48),
          _createElementVNode("li", {
            class: "featureItem",
            onClick: goKf
          }, _hoisted_54),
          _createElementVNode("li", {
            class: "featureItem",
            onClick: _withModifiers(goWatchManage, ["prevent"])
          }, _hoisted_58, 8, _hoisted_55),
          _createElementVNode("li", {
            class: "featureItem",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (officialStatus.value = true), ["prevent"]))
          }, _hoisted_61)
        ]),
        _createVNode(_component_van_popup, {
          show: appletStatus.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((appletStatus).value = $event)),
          round: "",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _hoisted_62,
            _createElementVNode("img", {
              src: cardData.value.watchMiniAppQrCodeUrl || _unref(appletImg),
              alt: "",
              class: "popupImg"
            }, null, 8, _hoisted_63),
            _createVNode(_component_van_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (appletStatus.value = false), ["prevent"])),
              class: "popupBtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: officialStatus.value,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((officialStatus).value = $event)),
          round: "",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _hoisted_64,
            _createElementVNode("img", {
              src: cardData.value.watchCustomerServiceQrCodeUrl || _unref(officialImg),
              alt: "",
              class: "popupImg"
            }, null, 8, _hoisted_65),
            _createVNode(_component_van_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (officialStatus.value = false), ["prevent"])),
              class: "popupBtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_popup, {
          show: phoneStatus.value,
          "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((phoneStatus).value = $event)),
          round: "",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _hoisted_66,
            _createVNode(_component_van_form, { onSubmit: onSubmit }, {
              default: _withCtx(() => [
                _createVNode(_component_van_cell_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_field, {
                      modelValue: _unref(phone),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(phone) ? (phone).value = $event : phone = $event)),
                      type: "tel",
                      placeholder: "请输入手机号",
                      maxlength: "11",
                      rules: [{ required: true, message: '请输入手机号' }]
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_van_field, {
                      modelValue: _unref(code),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(code) ? (code).value = $event : code = $event)),
                      type: "number",
                      placeholder: "请输入短信验证码",
                      maxlength: "4",
                      rules: [{ required: true, message: '请输入短信验证码' }]
                    }, {
                      button: _withCtx(() => [
                        _createVNode(_component_van_button, {
                          size: "small",
                          onClick: getCode,
                          disabled: sendCodeButtonText.value !== '发送验证码',
                          "loading-text": "发送中..."
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(sendCodeButtonText.value), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_van_button, {
                    round: "",
                    block: "",
                    type: "primary",
                    "native-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 校验 ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}
}

})